export default __webpack_public_path__ + "static/media/ag-icon.cee90139.svg";